export default class Error {
  constructor(error) {
    this.error = error
  }

  get isCrossBoundaries() {
    return this.error.code === 'calendar_boundaries_crossed'
  }

  get isAllowanceInsufficient() {
    return this.error.code === 'allowance_insufficient'
  }

  get isCalendarNotSetup() {
    return this.error.code === 'calendar_not_setup'
  }

  get isNoticePeriodPolicyViolation() {
    return this.error.code === 'leave_request_notice_period_policy_error'
  }

  get violationReason() {
    return this.error.violation_reason
  }

  get noticePeriodDays() {
    return this.error.notice_period_days
  }

  get leaveTypeName() {
    return this.error.leave_type_name
  }

  get noticePeriodPolicyViolationText() {
    if (!this.isNoticePeriodPolicyViolation) return ''

    if (this.violationReason === 'past_date') {
      return `${this.leaveTypeName} cannot be requested for past dates.`
    }

    return `${this.leaveTypeName} requires ${this.noticePeriodDays} days notice period.`
  }

  get isOutsideOfEmploymentPeriod() {
    return this.error.code === 'leave_requesting_outside_of_employment_period'
  }

  get isMaximumLeaveRequestPolicyViolation() {
    return this.error.code === 'maximum_leave_request_policy_error'
  }

  get dayCount() {
    return this.error.day_count
  }

  get maxDays() {
    return this.error.max_days
  }

  get countType() {
    return this.error.count_type
  }

  get countTypeLabel() {
    return this.countType === 'working_days' ? 'working' : 'calendar'
  }

  get contacts() {
    return this.error.contacts
  }

  _days(count) {
    return `${count} ${this.countTypeLabel} ${count === 1 ? 'day' : 'days'}`
  }

  get maximumLeaveRequestPolicyViolationText() {
    if (!this.isMaximumLeaveRequestPolicyViolation) return ''

    return (
      `This request covers ${this._days(
        this.dayCount
      )}, but the maximum allowed is ` +
      `${this._days(this.maxDays)} per request. Contact ${
        this.contacts
      } to make the request on your behalf.`
    )
  }

  get isBookingPeriodPolicyViolation() {
    return this.error.code === 'leave_request_booking_period_policy_error'
  }

  get bookingPeriodPolicyViolationText() {
    if (!this.isBookingPeriodPolicyViolation) return ''

    return this.error.message
  }
}
